export default "__VITE_ASSET__BusF3q____"